import React, { useCallback, useEffect, useRef } from "react"
import types from "prop-types"
import Modal, { ModalHeader } from "shared/Modal"
import { useModal } from "hooks"
import { useCategoryResetContext } from "contexts/CategoryResetContext"
import { successToast, errorToast } from "shared/toast"
import CategoryResetProcessingCheck from "./CategoryResetProcessingCheck"

const CategoryResetProcessingModal = ({ subdomain }) => {
  const { modalIsOpen, openModal, closeModal } = useModal()
  const { categoryReset, setCategoryReset, clearCategoryReset } = useCategoryResetContext()
  const resetTimeoutRef = useRef(null)

  const { id, status } = categoryReset || {}

  const close = useCallback(() => {
    closeModal()
    resetTimeoutRef.current = setTimeout(() => {
      clearCategoryReset()
    }, 0)
  }, [closeModal, clearCategoryReset])

  useEffect(() => {
    if (id) {
      clearTimeout(resetTimeoutRef.current)
      openModal()
    }
  }, [id, openModal])

  useEffect(() => {
    if (status === "failed") {
      errorToast("Unable to reset solution")
      close()
    }
  }, [status, close])

  useEffect(() => {
    if (status === "done") {
      successToast("Solution has been reset.")
      close()
    }
  }, [status, close])

  return (
    <Modal isOpen={modalIsOpen}>
      <ModalHeader closeModal={close} heading="Resetting Solution" />
      {id && (
        <CategoryResetProcessingCheck
          categoryResetId={id}
          setCategoryReset={setCategoryReset}
          onError={close}
          subdomain={subdomain}
        />
      )}
    </Modal>
  )
}

CategoryResetProcessingModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  subdomain: types.string.isRequired,
}

export default CategoryResetProcessingModal
